import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { ref, onValue } from 'firebase/database';
import { auth, db } from '../firebase';
import { isLicenseDateExpired } from '../utils/planLimits';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);       // Firebase Authユーザー
  const [userProfile, setUserProfile] = useState(null); // DBのユーザー情報
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setLoading(true);
        setUser(firebaseUser);
        // DBからロール・ライセンス情報を取得
        const userRef = ref(db, `users/${firebaseUser.uid}`);
        const unsubscribeDB = onValue(userRef, (snapshot) => {
          setUserProfile(snapshot.val());
          setLoading(false);
        });
        return () => unsubscribeDB();
      } else {
        setUser(null);
        setUserProfile(null);
        setLoading(false);
      }
    });

    return () => unsubscribeAuth();
  }, []);

  const normalizedRole = userProfile?.role?.trim()?.toLowerCase();
  const isSuperAdmin = normalizedRole === 'superadmin';
  const isOwner = normalizedRole === 'owner';
  const isStaff = normalizedRole === 'staff';
  const isGuest = normalizedRole === 'guest';
  const isLicenseActive = userProfile?.license?.status === 'active';
  const plan = userProfile?.license?.plan ?? null;
  // ライセンス期限切れ（status=activeだが expires_at を過ぎている owner）
  const isLicenseExpired = isOwner &&
    !!(userProfile?.license?.expires_at && isLicenseDateExpired(userProfile.license.expires_at));

  return (
    <AuthContext.Provider value={{
      user,
      userProfile,
      loading,
      isSuperAdmin,
      isOwner,
      isStaff,
      isGuest,
      isLicenseActive,
      isLicenseExpired,
      plan
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
